"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
* @class ScrollBox
* @desc ScrollBox adds a shadow to the top or bottom of the container when there's content to scroll to that way.
*
* @param {string} [data-id="scroll-box"]
*     To define the base "data-id" value for the top-level HTML container.
* @param {string} [className]
*     CSS classes to be set on the top-level HTML container.
* @param {number} [height]
*     Sets the maximum height for the container.
* @param {boolean} [fixHeight=false]
*     When true, the height prop will set the height rather than just the maximum height.
* @example
*
*   <ScrollBox>
*       Spicy jalapeno bacon ipsum dolor amet tenderloin sirloin bacon biltong pork belly
*       ribeye cow capicola tri-tip flank chuck tail ham venison.
*       Meatloaf ground round turkey corned beef pork belly boudin.
*       Pancetta ball tip meatloaf venison doner, landjaeger turkey pork bacon
*       ribeye prosciutto chicken turducken.
*       Pork loin shoulder salami frankfurter chicken.
*   </ScrollBox>
*/
var ScrollBoxShadow = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(ScrollBoxShadow, _React$PureComponent);

  var _super = _createSuper(ScrollBoxShadow);

  function ScrollBoxShadow() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, ScrollBoxShadow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      show: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setShow", function (value) {
      return _this.setState({
        show: value
      });
    });
    return _this;
  }

  (0, _createClass2.default)(ScrollBoxShadow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames2.default)(className, (0, _defineProperty2.default)({}, "".concat(className, "--show"), this.state.show))
      }, children);
    }
  }]);
  return ScrollBoxShadow;
}(_react.default.PureComponent);

(0, _defineProperty2.default)(ScrollBoxShadow, "propTypes", {
  className: _propTypes.default.string
});

var ScrollBox = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ScrollBox, _React$Component);

  var _super2 = _createSuper(ScrollBox);

  function ScrollBox() {
    var _context2;

    var _this2;

    (0, _classCallCheck2.default)(this, ScrollBox);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, (0, _concat.default)(_context2 = [this]).call(_context2, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_handleScroll", function () {
      var inner = _reactDom.default.findDOMNode(_this2.inner);

      var outer = _reactDom.default.findDOMNode(_this2.outer);

      var innerHeight = inner.scrollHeight;
      var outerHeight = outer.clientHeight;
      var scrollTop = inner.scrollTop;

      _this2.topShadow.setShow(scrollTop > 0);

      _this2.bottomShadow.setShow(innerHeight > outerHeight + scrollTop);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "componentDidUpdate", function () {
      return _this2._handleScroll();
    });
    return _this2;
  }

  (0, _createClass2.default)(ScrollBox, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          dataId = _this$props2["data-id"],
          height = _this$props2.height,
          fixHeight = _this$props2.fixHeight,
          props = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "className", "data-id", "height", "fixHeight"]);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames2.default)("scroll-box", className),
        "data-id": dataId,
        ref: function ref(el) {
          return _this3.outer = el;
        }
      }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
        className: "scroll-box__content",
        onScroll: this._handleScroll,
        ref: function ref(el) {
          return _this3.inner = el;
        },
        style: height !== undefined ? (0, _defineProperty2.default)({}, fixHeight ? "height" : "maxHeight", height) : {}
      }, props), children), /*#__PURE__*/_react.default.createElement(ScrollBoxShadow, {
        className: "scroll-box__top-shadow",
        ref: function ref(el) {
          return _this3.topShadow = el;
        }
      }), /*#__PURE__*/_react.default.createElement(ScrollBoxShadow, {
        className: "scroll-box__bottom-shadow",
        ref: function ref(el) {
          return _this3.bottomShadow = el;
        }
      }));
    }
  }]);
  return ScrollBox;
}(_react.default.Component);

(0, _defineProperty2.default)(ScrollBox, "propTypes", {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  height: _propTypes.default.number,
  fixHeight: _propTypes.default.bool
});
(0, _defineProperty2.default)(ScrollBox, "defaultProps", {
  "data-id": "scroll-box",
  fixHeight: false
});
var _default = ScrollBox;
exports.default = _default;
module.exports = exports["default"];